import {
  IComparator,
  IEntity,
  StandardEntity,
} from '@infodata-group/inf-commons';

export class Account extends StandardEntity implements IComparator, IEntity {
  lock: boolean;

  constructor(name: string, value: string) {
    super(name, value);
  }

  toString() {
    return `(${this.id}) ${this.label}`;
  }

  serialize(): any {
    return {
      id: this.id,
      label: this.label,
    };
  }

  compare(comparant: Account): number {
    return this.id === comparant.id ? 0 : 1;
  }

  getId(): string {
    return this.id;
  }

  getLabel(): string {
    return this.label;
  }
}
